// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__iBJib","name":"tooltip_name__uJgd_","culture":"tooltip_culture__K8X09","series":"tooltip_series__WRsic","label":"tooltip_label__L4O0U"};